import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { useIsOfferLocked } from '@/hooks/use-is-offer-locked';
import { hasDigitalProductsWithoutCouponCodesAtom } from '@/states/has-digital-products-without-coupon-codes.state';
import { vatRatesAtom } from '@/states/vat-rates.state';
import { useAtomValue } from 'jotai';
import { AlertTriangle, ChevronRight } from 'lucide-react';

interface AlertButtonProps {
  onClick: () => void;
}

export const AlertButton: React.FC<AlertButtonProps> = ({ onClick }) => {
  const isLocked = useIsOfferLocked();

  const { t } = useTranslation();
  const { uniqueVatRates } = useAtomValue(vatRatesAtom);
  const hasDigitalProductsWithoutCoupons = useAtomValue(
    hasDigitalProductsWithoutCouponCodesAtom
  );

  const alertCount =
    (uniqueVatRates.length > 1 ? 1 : 0) +
    (hasDigitalProductsWithoutCoupons ? 1 : 0);

  if (alertCount === 0) {
    return null;
  }

  return (
    <div className="flex w-full items-center justify-center pt-4 shadow-sm">
      <Button
        variant="outline"
        size="lg"
        onClick={isLocked ? undefined : onClick}
        className="w-full rounded-md border border-orange-200 bg-orange-50 p-4 hover:bg-orange-100"
        disabled={isLocked}
      >
        <div className="flex w-full items-center gap-4 px-2">
          <AlertTriangle className="h-4 w-4 text-orange-500" />
          <span className="text-orange-500">
            {t('components.alert_button.text_alerts', { count: alertCount })}
          </span>
          <div className="ml-auto flex cursor-pointer items-center text-sm">
            <ChevronRight className="h-4 w-4" />
          </div>
        </div>
      </Button>
    </div>
  );
};
